export enum UsageTabEvent {
    ViewStatusUsageBoard = 'UsageTab.ViewStatusUsageBoard',
    ViewProductUsageBoard = 'UsageTab.ViewProductUsageBoard',
}
